/**
 * Generate a unique SKU from product name
 * Format: KAVO-CATEGORY-KEYWORDS-RANDOMNUMBER
 */
export const generateSKU = (productName: string): string => {
  if (!productName || productName.trim().length === 0) {
    return ''
  }

  // Clean and convert to uppercase
  const cleaned = productName
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens

  // Take first few words (max 3-4 words)
  const parts = cleaned.split('-').filter(p => p.length > 0).slice(0, 4)

  // Generate a random suffix (to ensure uniqueness)
  const randomNum = Math.floor(Math.random() * 1000)
    .toString()
    .padStart(3, '0')

  // Combine: KAVO + words + random number
  const sku = ['KAVO', ...parts, randomNum].join('-')

  // Ensure it doesn't exceed 50 characters (database limit)
  return sku.substring(0, 50)
}
